import { Container, Grid, Typography } from '@mui/material';
import { SERVICE_ID_FOR_JOB_DETAILS } from '@/constants';

interface JobPreferencesProps {
  jobPreferences: string[];
  serviceName: string;
}
const JobPreferences = ({ jobPreferences, serviceName }: JobPreferencesProps) => {
  const headline = () => {
    switch (serviceName) {
      case SERVICE_ID_FOR_JOB_DETAILS.housekeeping:
        return 'Housekeeper preferences';
      case SERVICE_ID_FOR_JOB_DETAILS.tutoring:
        return 'Tutor preferences';
      default:
        return 'Caregiver preferences';
    }
  };

  return (
    <Container maxWidth="md" sx={{ pt: 1 }}>
      <Typography variant="h2" mb={2}>
        {headline()}
      </Typography>
      <Grid container>
        {jobPreferences.map((value) => (
          <Grid item xs={12} sm={4} key={value}>
            <Typography variant="body2" display="list-item" my={1} mx={2.5}>
              {value}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default JobPreferences;
